import React from 'react';
function Overlay({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <rect width="12.7" height="12.7" x="3.65" y="3.65" rx="1.35" />
      <rect width="12.7" height="12.7" x="7.65" y="7.65" rx="1.35" />
      <path d="M7.5 12.5l5-5M11.5 16.5l5-5M7.5 16.5l9-9" />
    </svg>
  );
}

export default Overlay;
